/* eslint-disable jsx a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions,  jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import { getImgAltText } from 'utils/alt-attribute-helper';
import { get } from 'lodash';

const GalleryImages = ({
    element, images, handleOpenModalGallery, withFade,
}) =>
{
    const [revealed, setRevealed] = useState({});

    const fadeRevealed = (id) =>
    {
        setRevealed(prevState => ({ ...prevState, [id]: true }));
    };

    return (
        <div className="tw-flex tw-flex-wrap tw-justify-center tw-mt-16 lg:tw-mt-16">
            {
                images.map((image, index) => (
                    <React.Fragment key={image.id}>
                        <Fade bottom onReveal={() => fadeRevealed(image.id)}>
                            <div className="tw-w-1/2 xl:tw-w-1/3 tw-p-2 md:tw-p-5">
                                { (!withFade || get(revealed, image.id, false)) && (
                                    <img
                                        loading="lazy"
                                        className="tw-cursor-pointer"
                                        onClick={() => handleOpenModalGallery(index)}
                                        src={image.path}
                                        alt={getImgAltText(element)}
                                    />
                                )}
                            </div>
                        </Fade>
                    </React.Fragment>
                ))
            }
        </div>
    );
};

GalleryImages.defaultProps = {
    withFade: false,
};

GalleryImages.propTypes = {
    handleOpenModalGallery: PropTypes.func.isRequired,
    element: PropTypes.string.isRequired,
    images: PropTypes.array.isRequired,
    withFade: PropTypes.bool,
};

export default GalleryImages;
